export default "__VITE_ASSET__B6GK05mc__"